import * as React from "react";
import styles from "./ButtonField.module.scss";

export type ButtonFieldProps = {
  id: string;
  label: string;
  onButtonClick: () => void;
  disabled?: boolean;
};

function ButtonField({ id, label, onButtonClick }: ButtonFieldProps): JSX.Element {
  return (
    <div className={styles.ButtonField}>
      <button id={id} onClick={onButtonClick}>
        {label}
      </button>
    </div>
  );
}

export default ButtonField;
